<template>
  <AppEventContainer feature="Manage Events">
    <AppScreenTitle title="Manage Events" />

    <AppTab :tabs="['Current', 'Past']" :selected-tab="activeView" @tab-selected="handleTabSelected"></AppTab>


    <EventList :is-loading="isLoading" :events="displayedEvents || []" :view-context='activeView.toLowerCase()'
      @event-click="editItem">
    </EventList>

  </AppEventContainer>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import useEvent from "@/modules/useEvent";
import PokerRunEventDataService from "@/services/PokerRunEventDataService";
import { PokerRunEvent } from "@models/PokerRunEvent";
import { useUserProfileStore } from "@/store/UserProfile";
import EventList from "@/components/EventList.vue";
import AppTab from "@/components/AppTab.vue";

const userProfileStore = useUserProfileStore();
const router = useRouter();
const { isPastEvent } = useEvent();
const activeView = ref<'Current' | 'Past'>("Current");
const pastPokerRuns = ref<PokerRunEvent[] | null>([]);
const currentPokerRuns = ref<PokerRunEvent[] | undefined>();
const isLoading = ref(true);

const displayedEvents = computed(() => {
  return activeView.value === 'Current'
    ? currentPokerRuns.value
    : pastPokerRuns.value || [];
});

function editItem(pokerRun: PokerRunEvent) {
  router.push({ name: "ManageEventSummary", params: { id: pokerRun.id } });
}


const handleTabSelected = (tab: 'Current' | 'Past') => {
  activeView.value = tab;
};

const initalize = async () => {
  try {
    const items = [];
    if (userProfileStore.isSupportAdmin) {
      items.push(...(await PokerRunEventDataService.getAll()));
    } else {
      items.push(
        ...(await PokerRunEventDataService.getHostedPokerRuns(
          userProfileStore.profile.id,
          false
        ))
      );
    }

    currentPokerRuns.value = items.filter((x) => !isPastEvent(x));
    pastPokerRuns.value = items.filter((x) => isPastEvent(x));

    currentPokerRuns.value.sort((a, b) => {
      return new Date(a.eventDate as string).getTime() - new Date(b.eventDate as string).getTime();
    });

    pastPokerRuns.value.sort((a, b) => {
      return new Date(b.eventDate as string).getTime() - new Date(a.eventDate as string).getTime();
    });
  } catch (error) {
    console.error("Error loading events:", error);
  } finally {
    isLoading.value = false;
  }
};

initalize();
</script>
